import { defineMessages } from 'react-intl'

export const systemStatesMessages = defineMessages({
  title: {
    id: 'systemStates.title',
    description: 'Title for system states page',
    defaultMessage: 'System States',
  },
  searchPlaceholder: {
    id: 'systemStates.searchPlaceholder',
    description: 'search Placeholder for system states page',
    defaultMessage: 'Search States',
  },
  noStatesFound: {
    id: 'systemStates.noStatesFound',
    description: 'No System States found message for system states page',
    defaultMessage: 'No System States found',
  },
  stateNameColumn: {
    id: 'systemStates.stateNameColumn',
    description: 'Name for table column "State Name" on system states page',
    defaultMessage: 'State Name',
  },
  stateValueColumn: {
    id: 'systemStates.stateValueColumn',
    description: 'Name for table column "State Value" on system states page',
    defaultMessage: 'State Value',
  },
  stateTypeColumn: {
    id: 'systemStates.stateTypeColumn',
    description: 'Name for table column "State Type" on system states page',
    defaultMessage: 'State Type',
  },
})
